import {NgModule} from '@angular/core';
import {LayoutComponent} from './layout.component';
import {RouterModule} from '@angular/router';
import {FooterComponent} from './footer/footer.component';
import {TopbarComponent} from './topbar/topbar.component';
import {CommonModule} from '@angular/common';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedUiModule} from '../shared/ui/shared-ui.module';

@NgModule({
    declarations: [ LayoutComponent, FooterComponent, TopbarComponent ],
    imports: [
        CommonModule,
        RouterModule,
        NgbDropdownModule,
        SharedUiModule,
    ],
})

export class LayoutsModule {
}
